<!--
* An image + text as useful information/tip component
* Takes url of the image, shows the image, text and exclamation mark
* @param {string} iconImageUrl - Url of the icon image
* @param {string} iconImageAlt - Alt text of the icon image
* @param {string} imageUrl - Url of the image
* @param {string} imageAlt - Alt text of the image
* @param {string} slot - Right handside content
* 
-->
<template>
      <div class="ms_help_info">
      <img
        :src="iconImageUrl"
        class="ms_help_info__info_icon"
        :alt="iconImageAlt">
      <img
        :src="imageUrl"
        class="ms_help_info__baggage_icon"
        :alt="imageAlt">
      <div class="ms_help_info__text">
        <slot></slot>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MsHelpInfo',
  props: {
    iconImageUrl: {
      type: String
    },
    iconImageAlt: {
      type: String
    },
    imageUrl: {
      type: String
    },
    imageAlt: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../assets/sass/shared.scss";

  .ms_help_info {
    display: flex;
    align-items: flex-start;
    margin: $dims-spacing-large 0;
  }

  .ms_help_info__info_icon,
  .ms_help_info__baggage_icon {
    margin-right: $dims-spacing-small;
  }

  .ms_help_info__info_icon {
    width: $dims-baggage-dimensions-info-icon-width;
    height: 100%;
  }

  .ms_help_info__baggage_icon {
    width: $dims-baggage-dimensions-icon-width;
    height: 100%;
  }

  .ms_help_info__text {
    display: inline-flex;
    align-items: center;
  }  
</style>